import VisitorIcon from '@mui/icons-material/People';
import { ActivityList } from "./components/ActivityList";

const resource = {
    list: ActivityList,
    icon: VisitorIcon,
  };


export default resource;